import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function LandingPage() {
  // Using a plain HTML form so Netlify can capture submissions without JS.

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-muted p-8">
      <header className="max-w-6xl mx-auto py-12">
        <img src="/assets/logo.png" alt="" className="h-24 mx-auto" />
        <p className="mt-2 text-muted-foreground max-w-2xl">
          Convert customer emails into real Shopify orders automatically. Reduce manual work,
          capture more sales, and give customers a faster checkout experience — all without
          changing how you collect orders today.
        </p>
      </header>

      <main className="max-w-6xl mx-auto grid gap-12 md:grid-cols-2">
        <section className="space-y-6">
          <h2 className="text-2xl font-semibold">Why merchants love CartInbox</h2>
          <ul className="space-y-4 list-disc pl-5 text-muted-foreground">
            <li>
              Capture orders from customer emails automatically — no manual entry required.
            </li>
            <li>
              Uses AI to understand intent and match products from your Shopify catalog.
            </li>
            <li>Email is a preferred channel for many customers, and it converts better with CartInbox</li>
            <li>Easy integration, one click install on your Shopify store</li>
          </ul>

          <h3 className="text-lg font-medium">Who should join the waitlist?</h3>
          <p className="text-muted-foreground">
            Store owners who receive orders or inquiries by email, teams that manually enter
            orders into Shopify, and merchants who want to recover sales from delayed replies.
            Early adopters get a free trial and priority onboarding.
          </p>
        </section>

        <aside>
          <Card>
            <CardHeader>
              <CardTitle>Join the waitlist</CardTitle>
            </CardHeader>
            <CardContent>
              <form
                name="waitlist"
                method="POST"
                data-netlify="true"
                className="space-y-4"
              >
                <input type="hidden" name="form-name" value="waitlist" />

                <div>
                  <Label htmlFor="name">Full name</Label>
                  <Input id="name" name="name" type="text" placeholder="Jane Doe" required />
                </div>

                <div>
                  <Label htmlFor="website">Website or store URL</Label>
                  <Input id="website" name="website" type="url" placeholder="yourstore.com" />
                </div>

                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" name="email" type="email" placeholder="you@store.com" required />
                </div>

                <Button type="submit" className="w-full">
                  Join Waitlist
                </Button>

                <p className="text-sm text-muted-foreground">
                  We'll only use your email to invite you and send onboarding information.
                </p>
              </form>
            </CardContent>
          </Card>
        </aside>
      </main>

      <footer className="max-w-4xl mx-auto py-8">
        <img src="/assets/demo.jpg" alt="" className="w-full rounded-md shadow" />
      </footer>
    </div>
  );
}

export default LandingPage;
